import { render, staticRenderFns } from "./OrderBase.vue?vue&type=template&id=7c4f4748&"
import script from "./OrderBase.vue?vue&type=script&lang=js&"
export * from "./OrderBase.vue?vue&type=script&lang=js&"
import style0 from "./OrderBase.vue?vue&type=style&index=0&id=7c4f4748&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports